var layout_default = {
  "layout": "L-Gor",
  "cell": "Q-Ybz"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
